export default "__VITE_ASSET__acf35e55__"